/* eslint-disable max-len */
import {conditionType} from '../../../../../pages/esgManager/interface/inputType';
import {
  createHeading,
  createRowMultiSelectField,
  createRowNumberField,
  createRowSelectField,
  createRowWysiwygField,
  createSelectField,
  createTableQuestion
} from '../../../Utils/questionHelper';
import {COUNTRY_OPTIONS} from '../SME/smeQuestions';

import {
  ASM_INTERVENTION_TYPE_OPTIONS,
  AVOIDANCE_MINIMIZATION_OPTIONS,
  BIODIVERSITY_ACTION_AREA_OPTIONS,
  BIODIVERSITY_ACTION_EFFECTIVENESS_OPTIONS,
  BIODIVERSITY_ACTION_PROGRESS_OPTIONS,
  BIODIVERSITY_ACTION_TYPE_OPTIONS,
  BIODIVERSITY_ASSESSMENT_STATUS_OPTIONS,
  BIODIVERSITY_HABITAT_DISTURBED_OPTIONS,
  BIODIVERSITY_IMPACT_MITIGATION_OPTIONS,
  BIODIVERSITY_IMPACT_TYPES_OPTIONS,
  BIODIVERSITY_IMPORTANT_AREA_OPTIONS,
  BIODIVERSITY_INDICATOR_TYPE_OPTIONS,
  BIODIVERSITY_INDICATOR_USAGE_OPTIONS,
  BIODIVERSITY_MANAGEMENT_MEASURE_OPTIONS,
  BIODIVERSITY_MITIGATION_TYPE_OPTIONS,
  BIODIVERSITY_OFFSET_TYPE_OPTIONS,
  BIODIVERSITY_PROXIMITY_OPTIONS,
  BIODIVERSITY_REVIEW_FREQUENCY_OPTIONS,
  BIODIVERSITY_RISK_POTENTIAL_OPTIONS,
  BIODIVERSITY_STRATEGIC_INTEGRATION_OPTIONS,
  BIODIVERSITY_TEAM_COVERAGE_OPTIONS,
  BIODIVERSITY_TEAM_SIZE_OPTIONS,
  BIODIVERSITY_TIMEFRAME_OPTIONS,
  COMPLIANCE_TYPE_OPTIONS,
  ECOSYSTEM_TYPE_OPTIONS,
  ENVIRONMENTAL_ASPECT_STRATEGY_OPTIONS,
  ENVIRONMENTAL_DISCLOSURE_STATUS_OPTIONS,
  ENVIRONMENTAL_IMPACT_LIKELIHOOD_OPTIONS,
  ENVIRONMENTAL_IMPACT_SEVERITY_OPTIONS,
  ENVIRONMENTAL_IMPACT_TYPE_OPTIONS,
  ENVIRONMENTAL_MANAGEMENT_DOCUMENT_TYPE_OPTIONS,
  ENVIRONMENTAL_REVIEW_FREQUENCY_OPTIONS,
  INFLUENCE_MINING_PROJECT_OPTIONS,
  IS_COLLABORATING_WITH_NGO_OPTIONS,
  IS_FINANCE_PROVISION_MINE_CLOSURE_OPTIONS,
  LANDSCAPE_INITIATIVE_PARTICIPATION_OPTIONS,
  MINING_OPERATION_LEGAL_STATUS_OPTIONS,
  MINING_PROJECT_CHALLENGES_OPTIONS,
  MINING_PROJECT_LOCATION_OPTIONS,
  PROJECT_OPTIONS,
  PROTECTED_AREA_CATEGORY_OPTIONS,
  REPORTING_SCOPE_OPTIONS,
  SCOPE_OF_COLLABORATION_OPTIONS,
  TARGET_LIST_OPTIONS,
  TIMEFRAME_OPTIONS,
  YES_NO_NO_DATA_OPTIONS,
  YES_NO_NOT_ALL_PROJECTS_OPTIONS,
  YES_NO_OPTIONS,
  YES_NO_PARTIALLY_OPTIONS
} from './corporateOptions';
import {CDP_BIODIVERSITY_KEYS} from './corporateQuestionsKeys';

export const environmentalPerformanceBiodiversityQuestions = [
  {
    key: 'Q1',
    showIndex: false,
    items: [
      {
        field: [
          createHeading(
            '11.1 Within your reporting boundary, are there any geographical areas, business units or mining projects excluded from your disclosure?',
            'CDP seeks to share comprehensive and representative biodiversity-related data. If companies need to exclude areas of their business from their disclosure, data users must be informed of the exclusions as this may affect their analysis.'
          ),
          createSelectField(CDP_BIODIVERSITY_KEYS.Q1_VALUE, '', YES_NO_OPTIONS)
        ]
      }
    ]
  },
  {
    key: 'Q2',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_BIODIVERSITY_KEYS.Q2_VALUE,
        '11.1.1 Please report your exclusions and describe their potential for biodiversity-related risk.',
        'CDP seeks to share comprehensive and representative biodiversity-related data. Data users need to be informed of exclusions that may affect their analysis.',
        [
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q2_1_VALUE,
            'Exclusion',
            REPORTING_SCOPE_OPTIONS
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q2_2_VALUE,
            'Description of exclusion',
            2400
          ),
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q2_3_VALUE,
            'Potential for biodiversity-related risk',
            BIODIVERSITY_RISK_POTENTIAL_OPTIONS
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q2_4_VALUE,
            'Please explain',
            2400
          )
        ],
        true,
        undefined,
        CDP_BIODIVERSITY_KEYS.Q1_VALUE,
        ['Yes']
      )
    ]
  },
  {
    key: 'Q3',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_BIODIVERSITY_KEYS.Q3_VALUE,
        '11.2 What actions has your organization taken in the reporting year to progress your biodiversity-related commitments?',
        'This question enables organizations to demonstrate how they are achieving their vision and ambition for biodiversity through addressing the issues they have identified and committed to addressing. Your response to this question aligns with requirements of “Stage 2: Ambitions” in IUCN’s Guidelines for planning and monitoring corporate biodiversity performance, which recommends that companies develop and deliver biodiversity goals and objectives.',
        [
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q3_1_VALUE,
            'Actions taken in the reporting period to progress your biodiversity-related commitments',
            BIODIVERSITY_ACTION_PROGRESS_OPTIONS
          ),
          createRowMultiSelectField(
            CDP_BIODIVERSITY_KEYS.Q3_2_VALUE,
            'Type of action taken to progress biodiversity-related commitments',
            BIODIVERSITY_ACTION_TYPE_OPTIONS,
            true,
            {
              fieldName: CDP_BIODIVERSITY_KEYS.Q3_1_VALUE,
              condition: conditionType.NOT_INCLUDES,
              values: [
                'Yes, we are taking actions to progress our biodiversity-related commitments'
              ]
            }
          )
        ]
      )
    ]
  },
  {
    key: 'Q4',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_BIODIVERSITY_KEYS.Q4_VALUE,
        '11.3 Does your organization use biodiversity indicators to monitor performance across its activities?',
        'Robust indicators are critical for a corporate-level assessment of biodiversity impact, by allowing the aggregation of data from different activities and geographies. This question allows an organization to demonstrate its use of indicators to track progress against its biodiversity goals and objectives and evaluate the success of its intervention/s. Your response to this question aligns with requirements of “Stage 3: Indicators” in IUCN’s Guidelines for planning and monitoring corporate biodiversity performance, which recommends that companies collect, share and analyse biodiversity data that encourages learning and improvement.',
        [
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q4_1_VALUE,
            'Does your organization use indicators to monitor biodiversity performance?',
            BIODIVERSITY_INDICATOR_USAGE_OPTIONS
          ),
          createRowMultiSelectField(
            CDP_BIODIVERSITY_KEYS.Q4_2_VALUE,
            'Indicators used to monitor biodiversity performance',
            BIODIVERSITY_INDICATOR_TYPE_OPTIONS
          )
        ]
      )
    ]
  },
  {
    key: 'Q5',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_BIODIVERSITY_KEYS.Q5_VALUE,
        '11.4 Does your organization have activities located in or near to areas important for biodiversity in the reporting year?',
        'Awareness of the proximity of your organization’s activities to areas important for biodiversity demonstrates an understanding of the relationship between the two. This awareness allows organizations to mitigate the potential negative effects of their activities on areas important for biodiversity',
        [
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q5_1_VALUE,
            'Type of area important for biodiversity',
            BIODIVERSITY_IMPORTANT_AREA_OPTIONS
          ),
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q5_2_VALUE,
            `Indicate whether any of your ${'organization'}'s activities are located in or near to this type of area important for biodiversity`,
            BIODIVERSITY_ASSESSMENT_STATUS_OPTIONS
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q5_3_VALUE,
            'Comment',
            2500
          )
        ]
      )
    ]
  },
  {
    key: 'Q6',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_BIODIVERSITY_KEYS.Q6_VALUE,
        '11.4.1 Provide details of your organization’s activities in the reporting year located in or near to areas important for biodiversity.',
        'Awareness of the proximity of your organization’s activities to areas important for biodiversity demonstrates an understanding of the relationship between the two. Information on your activities’ proximity to such areas provide insights to investors and other data users on potential risks. It also facilitates better understanding of what to expect from your organization in terms of commitments and actions related to this issue. This awareness allows organizations to mitigate potential negative effects of their activities on areas important for biodiversity.',
        [
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q6_1_VALUE,
            'Mining project ID',
            PROJECT_OPTIONS
          ),
          createRowMultiSelectField(
            CDP_BIODIVERSITY_KEYS.Q6_2_VALUE,
            'Types of area important for biodiversity',
            BIODIVERSITY_IMPORTANT_AREA_OPTIONS
          ),
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q6_3_VALUE,
            'Protected area category (IUCN classification)',
            PROTECTED_AREA_CATEGORY_OPTIONS
          ),
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q6_4_VALUE,
            'Country/area',
            COUNTRY_OPTIONS
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q6_5_VALUE,
            'Name of the area important for biodiversity',
            500
          ),
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q6_6_VALUE,
            'Proximity',
            BIODIVERSITY_PROXIMITY_OPTIONS
          ),
          createRowNumberField(
            CDP_BIODIVERSITY_KEYS.Q6_7_VALUE,
            'Area of overlap (hectares)',
            2,
            true,
            {
              fieldName: CDP_BIODIVERSITY_KEYS.Q6_6_VALUE,
              condition: conditionType.NOT,
              values: ['Overlap']
            }
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q6_8_VALUE,
            'Briefly describe your organization’s activities in the reporting year located in or near to the selected area',
            2500
          ),
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q6_9_VALUE,
            'Indicate whether any of your organization’s activities located in or near to the selected area could negatively affect biodiversity',
            BIODIVERSITY_IMPACT_MITIGATION_OPTIONS
          ),
          createRowMultiSelectField(
            CDP_BIODIVERSITY_KEYS.Q6_10_VALUE,
            'Mitigation measures implemented within the selected area',
            BIODIVERSITY_MITIGATION_TYPE_OPTIONS,
            true,
            {
              fieldName: CDP_BIODIVERSITY_KEYS.Q6_9_VALUE,
              condition: conditionType.NOT,
              values: ['Yes, but mitigation measures have been implemented']
            }
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q6_11_VALUE,
            'Explain how your organization’s activities located in or near to the selected area could negatively affect biodiversity, how this was assessed, and describe any mitigation measures implemented',
            3000,
            undefined,
            undefined,
            {
              fieldName: CDP_BIODIVERSITY_KEYS.Q6_9_VALUE,
              condition: conditionType.NOT,
              values: ['Not assessed']
            }
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q6_12_VALUE,
            'Further context for mining projects',
            1500
          )
        ],
        false,
        CDP_BIODIVERSITY_KEYS.Q5_VALUE,
        CDP_BIODIVERSITY_KEYS.Q5_2_VALUE,
        ['Yes', 'Yes (partial assessment)']
      )
    ]
  },
  {
    key: 'Q7',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_BIODIVERSITY_KEYS.Q7_VALUE,
        '11.5 Can you disclose the mining project area and the area of land disturbed for each of your mining projects?',
        'Mining organizations usually own, lease or manage large tracts of land, including areas that are not disturbed by mining-related activities. While land disturbed by mining-related activities represents a useful proxy for biodiversity-related impacts, information about the total area of land involved in the project allows understanding of what this disturbance represents in relative terms. This question provides investors and other data users with insights into your responsibilities as a land manager and the challenges associated with the future rehabilitation of the land disturbed.',
        [
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q7_1_VALUE,
            'Disclosing mining project area and area of land disturbed',
            BIODIVERSITY_ACTION_EFFECTIVENESS_OPTIONS
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q7_2_VALUE,
            'Comment',
            2400
          )
        ]
      )
    ]
  },
  {
    key: 'Q8',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_BIODIVERSITY_KEYS.Q8_VALUE,
        '11.5.1 Provide details on the mining project area and the area of land disturbed for each of your mining',
        'CDP is encouraging disclosure of asset-level data for land resources and land disturbed. Only project- level data provides the necessary granularity to relate the disclosed data to the environmental context within which the organization operates.',
        [
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q8_1_VALUE,
            'Mining project ID',
            PROJECT_OPTIONS
          ),
          createRowNumberField(
            CDP_BIODIVERSITY_KEYS.Q8_2_VALUE,
            'Total area of owned land/lease/project area (hectares)',
            2
          ),
          createRowNumberField(
            CDP_BIODIVERSITY_KEYS.Q8_3_VALUE,
            'Total area disturbed to date (hectares)',
            2
          ),
          createRowNumberField(
            CDP_BIODIVERSITY_KEYS.Q8_4_VALUE,
            'Area disturbed in the reporting year (hectares)',
            2
          ),
          createRowMultiSelectField(
            CDP_BIODIVERSITY_KEYS.Q8_5_VALUE,
            'Type(s) of habitat disturbed in the reporting year',
            BIODIVERSITY_HABITAT_DISTURBED_OPTIONS
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q8_6_VALUE,
            'Comment',
            2400
          )
        ],
        true,
        CDP_BIODIVERSITY_KEYS.Q7_VALUE,
        CDP_BIODIVERSITY_KEYS.Q7_1_VALUE,
        ['Yes', 'Partially']
      )
    ]
  },
  {
    key: 'Q9',
    showIndex: false,
    items: [
      {
        field: [
          createHeading(
            '11.6 Are there artisanal and small-scale mining (ASM) operations active in your mining project areas or in their area of influence?',
            'It is not unusual that large-scale mining projects come across artisanal and small-scale miners within their area of influence. Artisanal and small-scale mining (ASM) provides a source of livelihood for thousands of people but might also be associated with conflicts and environmental degradation, such as tropical deforestation. This data informs investors and other data users about potential challenges and risks you may be facing'
          ),
          createSelectField(
            CDP_BIODIVERSITY_KEYS.Q9_VALUE,
            '',
            YES_NO_NO_DATA_OPTIONS
          )
        ]
      }
    ]
  },
  {
    key: 'Q10',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_BIODIVERSITY_KEYS.Q10_VALUE,
        '11.6.1 Provide details on artisanal and small-scale mining operations active in your mining project areas or in their area of influence. Indicate the associated challenges, if there are any.',
        'This question gathers details about artisanal and small-scale mining operations active in your mining project areas or in their area of influence, as well as the associated challenges. It is important that this information is disclosed at asset-level, as it is unlikely that all projects face this issue.',
        [
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q10_1_VALUE,
            'Mining project ID',
            PROJECT_OPTIONS
          ),
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q10_2_VALUE,
            'Where does artisanal/small-scale mining operations occur?',
            MINING_PROJECT_LOCATION_OPTIONS
          ),
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q10_3_VALUE,
            'Legal status of artisanal and small-scale mining activity',
            MINING_OPERATION_LEGAL_STATUS_OPTIONS
          ),
          createRowMultiSelectField(
            CDP_BIODIVERSITY_KEYS.Q10_4_VALUE,
            'Type of challenges',
            MINING_PROJECT_CHALLENGES_OPTIONS
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q10_5_VALUE,
            'Please explain',
            2400
          )
        ],
        true,
        undefined,
        CDP_BIODIVERSITY_KEYS.Q9_VALUE,
        ['Yes']
      )
    ]
  },
  {
    key: 'Q11',
    showIndex: false,
    items: [
      {
        field: [
          createHeading(
            '11.7 Do you adopt biodiversity action plans to manage your impacts on biodiversity?',
            'The number of mining organizations adopting Biodiversity Action Plans (BAPs) in sites with high biodiversity risk is increasing. Developing BAPs in such cases can be seen as good practice and it might also be needed to demonstrate compliance with lender standards/requirements. BAPs complement existing environmental management systems, focusing on the organization’s biodiversity management strategy. Developing BAPs for high-risk sites provides an indication to investors and other data users that the organization is tackling its biodiversity risks.'
          ),
          createSelectField(CDP_BIODIVERSITY_KEYS.Q11_VALUE, '', YES_NO_OPTIONS)
        ]
      }
    ]
  },
  {
    key: 'Q12',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_BIODIVERSITY_KEYS.Q12_VALUE,
        '11.7.1 Describe your criteria for defining which sites are required to produce biodiversity action plans.',
        'As there is not a unique standard or guideline defining when Biodiversity Action Plans (BAPs) are required, organizations might adopt different criteria. This information provides clarity to investors and other data users on your criteria for when BAPs are required.',
        [
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q12_1_VALUE,
            'Description',
            5000
          )
        ]
      )
    ]
  },
  {
    key: 'Q13',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_BIODIVERSITY_KEYS.Q13_VALUE,
        '11.8 Provide details on mining projects that are required to produce Biodiversity Action Plans.',
        'This question asks details about the Biodiversity Action Plans (BAPs) your organization has in place. The number of mining organizations adopting BAPs for sites with high biodiversity risk is increasing. Developing BAPs in such cases is seen as a good practice and it might also be needed to demonstrate compliance with lender standards. BAPs complement existing environmental management systems, focusing the organization’s biodiversity management strategy. Developing BAPs for high-risk sites provides an indication to investors and other data users that the organization is actively dealing with biodiversity risks associated with the business.',
        [
          createRowNumberField(
            CDP_BIODIVERSITY_KEYS.Q13_1_VALUE,
            'Number of mining projects required to produce a BAP'
          ),
          createRowNumberField(
            CDP_BIODIVERSITY_KEYS.Q13_2_VALUE,
            '% of mining projects required to produce a BAP that have one in place'
          ),
          createRowMultiSelectField(
            CDP_BIODIVERSITY_KEYS.Q13_3_VALUE,
            'Format',
            ENVIRONMENTAL_MANAGEMENT_DOCUMENT_TYPE_OPTIONS
          ),
          createRowMultiSelectField(
            CDP_BIODIVERSITY_KEYS.Q13_4_VALUE,
            'Frequency BAPs are reviewed',
            ENVIRONMENTAL_REVIEW_FREQUENCY_OPTIONS
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q13_5_VALUE,
            'Please explain',
            2400
          )
        ]
      )
    ]
  },
  {
    key: 'Q14',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_BIODIVERSITY_KEYS.Q14_VALUE,
        '11.9 Have any of your projects caused, or have the potential to cause, significant adverse impact(s) on biodiversity?',
        'This question elicits information on whether your projects have caused or are expected to cause significant impacts on biodiversity. Large-scale mining projects have the potential to cause significant impacts on biodiversity, and these are not always avoidable. This information provides insights to investors and other data users on the primary challenges you face regarding biodiversity-related issues.',
        [
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q14_1_VALUE,
            'Any projects caused, or have the potential to cause, significant adverse impact(s) on biodiversity',
            ENVIRONMENTAL_DISCLOSURE_STATUS_OPTIONS
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q14_2_VALUE,
            'Comment',
            2400
          )
        ]
      )
    ]
  },
  {
    key: 'Q15',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_BIODIVERSITY_KEYS.Q15_VALUE,
        '11.9.1 For your disclosed mining projects, provide details of the significant adverse impacts on biodiversity, with the respective response to the impact.',
        'By disclosing significant biodiversity impacts you allow investors and other data users to better understand the biodiversity risks your organization faces, as well as the level of ambition of the response.',
        [
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q15_1_VALUE,
            'Mining project ID',
            PROJECT_OPTIONS
          ),
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q15_2_VALUE,
            'Type of impact',
            ENVIRONMENTAL_IMPACT_TYPE_OPTIONS
          ),
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q15_3_VALUE,
            'Impact',
            BIODIVERSITY_IMPACT_TYPES_OPTIONS
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q15_4_VALUE,
            'Description of the impact',
            2400
          ),
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q15_5_VALUE,
            'Consequence',
            ENVIRONMENTAL_IMPACT_SEVERITY_OPTIONS
          ),
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q15_6_VALUE,
            'Likelihood',
            ENVIRONMENTAL_IMPACT_LIKELIHOOD_OPTIONS
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q15_7_VALUE,
            'Describe response',
            2400
          )
        ],
        true,
        CDP_BIODIVERSITY_KEYS.Q14_VALUE,
        CDP_BIODIVERSITY_KEYS.Q14_1_VALUE,
        ['Yes']
      )
    ]
  },
  {
    key: 'Q16',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_BIODIVERSITY_KEYS.Q16_VALUE,
        '11.10 Are biodiversity issues integrated into any aspects of your long-term strategic business plan, and if so how?',
        `This question allows organizations to explain if and how they have considered and acted upon biodiversity-related issues at a high level. This question is not asking simply about your ${'organization'}'s response to biodiversity-related issues. Investors and other data users are interested in forward-looking strategic innovations and financial decisions that have been driven by market opportunities, public policy objectives, and corporate responsibility commitments related to biodiversity.`,
        [
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q16_1_VALUE,
            'Aspect of strategy',
            ENVIRONMENTAL_ASPECT_STRATEGY_OPTIONS
          ),
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q16_2_VALUE,
            'Are biodiversity-related issues integrated?',
            BIODIVERSITY_STRATEGIC_INTEGRATION_OPTIONS
          ),
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q16_3_VALUE,
            'Long-term time horizon (years)',
            BIODIVERSITY_TEAM_SIZE_OPTIONS
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q16_4_VALUE,
            'Please explain',
            2400
          )
        ]
      )
    ]
  },
  {
    key: 'Q17',
    showIndex: false,
    items: [
      {
        field: [
          createHeading(
            '11.11 Have you specified any measurable and time-bound targets related to your commitments to reduce or avoid impacts on biodiversity?',
            'This question asks about specific targets on avoiding or reducing biodiversity-related impacts and risks. Effective implementation of policies and commitments requires specific targets to be set. Ambitious targets reflect how urgent biodiversity issues are being addressed by organizations. Information disclosed about your targets provides CDP data users with a way of tracking your progress towards sustainability. Organizations also benefit from setting targets by having clear indicators of their progress towards better biodiversity stewardship.'
          ),
          createSelectField(CDP_BIODIVERSITY_KEYS.Q17_VALUE, '', YES_NO_OPTIONS)
        ]
      }
    ]
  },
  {
    key: 'Q18',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_BIODIVERSITY_KEYS.Q18_VALUE,
        '11.11.1 Provide details of your targets related to your commitments to reduce or avoid impacts on',
        'This question asks about specific biodiversity-related targets. Effective implementation of policies and commitments requires specific, measurable and time-bound targets to be set. Ambitious targets reflect how urgent biodiversity issues are being addressed by organizations. Information disclosed about your targets provides CDP data users with a way of tracking progress towards sustainability. Organizations also benefit from setting specific and measurable targets by having clear indicators of their progress towards better biodiversity stewardship.',
        [
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q18_1_VALUE,
            'Target reference number',
            TARGET_LIST_OPTIONS
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q18_2_VALUE,
            'Target label',
            2400
          ),
          createRowNumberField(
            CDP_BIODIVERSITY_KEYS.Q18_3_VALUE,
            'Base year',
            0
          ),
          createRowNumberField(
            CDP_BIODIVERSITY_KEYS.Q18_4_VALUE,
            'Target year',
            0
          ),
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q18_5_VALUE,
            '% of target achieved',
            BIODIVERSITY_TEAM_COVERAGE_OPTIONS
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q18_6_VALUE,
            'Please explain',
            2400
          )
        ],
        true,
        undefined,
        CDP_BIODIVERSITY_KEYS.Q17_VALUE,
        ['Yes']
      )
    ]
  },
  {
    key: 'Q19',
    showIndex: false,
    items: [
      {
        field: [
          createHeading(
            '11.12 Has your organization adopted avoidance and/or minimization as strategies to prevent or mitigate significant adverse impacts on biodiversity?',
            'Actions to mitigate impacts on biodiversity can be more effective and efficient if adopted at the early stages of the project. Later, mitigation measures are often more limited, costly and involve a higher degree of uncertainty about expected outcomes. Managing relevant impacts and risks by means of avoidance and minimization indicates to investor and other data users that your organization is aligned with sector best practices, as well as being more likely to prevent unforeseen risks.'
          ),
          createSelectField(CDP_BIODIVERSITY_KEYS.Q19_VALUE, '', YES_NO_OPTIONS)
        ]
      }
    ]
  },
  {
    key: 'Q20',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_BIODIVERSITY_KEYS.Q20_VALUE,
        '11.12.1 Provide relevant company-specific examples of your implementation of avoidance and minimization actions to manage adverse impacts on biodiversity.',
        'This question asks for relevant examples that provide evidence that significant biodiversity-related impacts and risks were managed by adopting avoidance and/or minimization actions.',
        [
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q20_1_VALUE,
            'Mining project ID',
            PROJECT_OPTIONS
          ),
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q20_2_VALUE,
            'Approach and type of measure',
            AVOIDANCE_MINIMIZATION_OPTIONS
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q20_3_VALUE,
            'Description',
            2400
          )
        ],
        true,
        undefined,
        CDP_BIODIVERSITY_KEYS.Q19_VALUE,
        ['Yes']
      )
    ]
  },
  {
    key: 'Q21',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_BIODIVERSITY_KEYS.Q21_VALUE,
        '11.13 Have significant impacts on biodiversity been mitigated through restoration?',
        'Restoration of biodiversity features is an option for compensating impacts that could not be avoided or minimized. It is an important step for organizations to achieve their commitments regarding reducing their impact on biodiversity (e.g. ‘No Net Loss’ or ‘Net Positive Impact’), and to manage regulatory and reputational risks. By indicating that you are taking action to reduce residual impacts, you provide an indication to investors and other stakeholders that your organization is adopting biodiversity management best practices',
        [
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q21_1_VALUE,
            'Have significant impacts on biodiversity been mitigated through restoration?',
            BIODIVERSITY_ACTION_EFFECTIVENESS_OPTIONS
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q21_2_VALUE,
            'Comment',
            2400
          )
        ]
      )
    ]
  },
  {
    key: 'Q22',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_BIODIVERSITY_KEYS.Q22_VALUE,
        '11.13.1 Provide details on restoration actions you have in place in your sites.',
        'By disclosing biodiversity restoration actions, you provide evidence to investors and other data users on your actions for implementing the mitigation hierarchy framework across your mining project(s).',
        [
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q22_1_VALUE,
            'Mining project ID',
            PROJECT_OPTIONS
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q22_2_VALUE,
            'Description of the impact being mitigated by restoration',
            2400
          ),
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q22_3_VALUE,
            'Type of ecosystem restored',
            ECOSYSTEM_TYPE_OPTIONS
          ),
          createRowNumberField(
            CDP_BIODIVERSITY_KEYS.Q22_4_VALUE,
            'Total area restored to date (hectares)',
            2
          ),
          createRowNumberField(
            CDP_BIODIVERSITY_KEYS.Q22_5_VALUE,
            'Total area to be restored (hectares)',
            2
          ),
          createRowNumberField(
            CDP_BIODIVERSITY_KEYS.Q22_6_VALUE,
            'Target year',
            0
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q22_7_VALUE,
            'Describe restoration actions',
            2400
          )
        ],
        true,
        CDP_BIODIVERSITY_KEYS.Q21_VALUE,
        CDP_BIODIVERSITY_KEYS.Q21_1_VALUE,
        ['Yes', 'Partially']
      )
    ]
  },
  {
    key: 'Q23',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_BIODIVERSITY_KEYS.Q23_VALUE,
        '11.14 Have significant residual impacts of your projects been compensated through biodiversity offsets?',
        'Biodiversity offsetting is a mechanism to compensate impacts on biodiversity that could not be otherwise mitigated. Offsets are usually essential to achieve “No Net Loss” or “Net Positive Impact” commitments. Financial institutions or governmental regulation might also require biodiversity offsets to be implemented by your organization. By disclosing the biodiversity offset projects, organizations demonstrate to investors and other data users that commitments are taken seriously.',
        [
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q23_1_VALUE,
            'Have residual impacts been compensated through biodiversity offsets?',
            BIODIVERSITY_ACTION_EFFECTIVENESS_OPTIONS
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q23_2_VALUE,
            'Comment',
            2400
          )
        ]
      )
    ]
  },
  {
    key: 'Q24',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_BIODIVERSITY_KEYS.Q24_VALUE,
        '11.14.1 Provide details on the biodiversity offsets you have in place.',
        'This question looks for evidence that your organization is adopting biodiversity offsetting.',
        [
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q24_1_VALUE,
            'Mining project ID',
            PROJECT_OPTIONS
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q24_2_VALUE,
            'Description of the impact being offset',
            2400
          ),
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q24_3_VALUE,
            'Motivation',
            COMPLIANCE_TYPE_OPTIONS
          ),
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q24_4_VALUE,
            'Type of offset',
            BIODIVERSITY_OFFSET_TYPE_OPTIONS
          ),
          createRowNumberField(
            CDP_BIODIVERSITY_KEYS.Q24_5_VALUE,
            'Area (hectares)',
            2
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q24_6_VALUE,
            'Describe the offset',
            2400
          )
        ],
        true,
        CDP_BIODIVERSITY_KEYS.Q23_VALUE,
        CDP_BIODIVERSITY_KEYS.Q23_1_VALUE,
        ['Yes', 'Partially']
      )
    ]
  },
  {
    key: 'Q25',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_BIODIVERSITY_KEYS.Q25_VALUE,
        '11.15 Is your organization implementing or supporting additional conservation actions?',
        'Some organizations have implemented Additional Conservation Actions (ACAs), which benefit biodiversity but do not aim at mitigating specific impacts. This question aims at providing a comprehensive picture of your organization’s biodiversity-related actions. By implementing ACAs, your organization sends a signal to investors and other data users that it is going beyond regulatory compliance when dealing with biodiversity-related issues.',
        [
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q25_1_VALUE,
            'Implementing or supporting additional conservation actions?',
            YES_NO_NO_DATA_OPTIONS
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q25_2_VALUE,
            'Comment',
            2400
          )
        ]
      )
    ]
  },
  {
    key: 'Q26',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_BIODIVERSITY_KEYS.Q26_VALUE,
        '11.15.1 Provide details on the main ACAs you are implementing or supporting.',
        'This question asks for evidence that your organization is supporting or implementing ACAs.',
        [
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q26_1_VALUE,
            'Project title',
            500
          ),
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q26_2_VALUE,
            'Project theme',
            BIODIVERSITY_ACTION_AREA_OPTIONS
          ),
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q26_3_VALUE,
            'Country/Area',
            COUNTRY_OPTIONS
          ),
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q26_4_VALUE,
            'Location',
            INFLUENCE_MINING_PROJECT_OPTIONS
          ),
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q26_5_VALUE,
            'Primary motivation',
            COMPLIANCE_TYPE_OPTIONS
          ),
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q26_6_VALUE,
            'Timeframe',
            TIMEFRAME_OPTIONS
          ),
          createRowNumberField(
            CDP_BIODIVERSITY_KEYS.Q26_7_VALUE,
            'Start year',
            0
          ),
          createRowNumberField(
            CDP_BIODIVERSITY_KEYS.Q26_8_VALUE,
            'End year',
            0
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q26_9_VALUE,
            'Description of project',
            500
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q26_10_VALUE,
            'Description of outcome to date',
            500
          )
        ],
        true,
        CDP_BIODIVERSITY_KEYS.Q25_VALUE,
        CDP_BIODIVERSITY_KEYS.Q25_1_VALUE,
        ['Yes']
      )
    ]
  },
  {
    key: 'Q27',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_BIODIVERSITY_KEYS.Q27_VALUE,
        '11.16 Do your mining projects have closure plans in place?',
        'Planning for mine closure helps prevent negative legacies and allows benefits to biodiversity to be maximized. By disclosing details on your closure plans, you provide evidence to investors and other data users that the impacts and risks associated with mine closure have been taken into consideration.',
        [
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q27_1_VALUE,
            'Are there closure plans in place?',
            YES_NO_NOT_ALL_PROJECTS_OPTIONS
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q27_2_VALUE,
            'Comment',
            2400
          )
        ]
      )
    ]
  },
  {
    key: 'Q28',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_BIODIVERSITY_KEYS.Q28_VALUE,
        '11.16.1 Please provide details on mines with closure plans.',
        'This question asks details about mine closure plans your organization has in place. This provides insights to investors and other data users on whether you are working towards the reduction of potential environmental liabilities of your mining project.',
        [
          createRowNumberField(
            CDP_BIODIVERSITY_KEYS.Q28_1_VALUE,
            '% of mines with closure plans'
          ),
          createRowNumberField(
            CDP_BIODIVERSITY_KEYS.Q28_2_VALUE,
            '% of closure plans that take biodiversity aspects into consideration'
          ),
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q28_3_VALUE,
            'Is there a financial provision for mine closure expenditure?',
            IS_FINANCE_PROVISION_MINE_CLOSURE_OPTIONS
          ),
          createRowMultiSelectField(
            CDP_BIODIVERSITY_KEYS.Q28_4_VALUE,
            'Frequency closure plans are reviewed',
            BIODIVERSITY_REVIEW_FREQUENCY_OPTIONS
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q28_5_VALUE,
            'Please explain',
            2400
          )
        ],
        false,
        CDP_BIODIVERSITY_KEYS.Q27_VALUE,
        CDP_BIODIVERSITY_KEYS.Q27_1_VALUE,
        ['Yes', 'Partially (not all projects)']
      )
    ]
  },
  {
    key: 'Q29',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_BIODIVERSITY_KEYS.Q29_VALUE,
        '11.17 Can you disclose the area rehabilitated (in total and in the reporting year) for each of your mining projects?',
        'Rehabilitation is a relevant environmental performance indicator in the case of mining projects. Well-planned and managed rehabilitation might reduce and/or avoid negative legacies, high compliance costs and regulatory risks.',
        [
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q29_1_VALUE,
            'Disclosing area rehabilitated (in total and in the reporting year)',
            YES_NO_PARTIALLY_OPTIONS
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q29_2_VALUE,
            'Comment',
            2400
          )
        ]
      )
    ]
  },
  {
    key: 'Q30',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_BIODIVERSITY_KEYS.Q30_VALUE,
        '11.17.1 Provide details on the area rehabilitated (total/reporting year) for each of your mining projects, including post-mining land use.',
        'CDP encourages disclosure of project-level data on rehabilitation. Only project-level data allows a robust assessment of the environmental context within which the organization operates. Information disclosed here will allow investors and other data users to understand your approach to rehabilitation throughout your mining projects and regions your organization operates.',
        [
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q30_1_VALUE,
            'Mining project ID',
            PROJECT_OPTIONS
          ),
          createRowNumberField(
            CDP_BIODIVERSITY_KEYS.Q30_2_VALUE,
            'Total area rehabilitated (hectares)',
            2
          ),
          createRowNumberField(
            CDP_BIODIVERSITY_KEYS.Q30_3_VALUE,
            'Area rehabilitated in the reporting year (hectares)',
            2
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q30_4_VALUE,
            'Describe post-mining land use',
            2400
          )
        ],
        true,
        CDP_BIODIVERSITY_KEYS.Q29_VALUE,
        CDP_BIODIVERSITY_KEYS.Q29_1_VALUE,
        ['Yes', 'Partially']
      )
    ]
  },
  {
    key: 'Q31',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_BIODIVERSITY_KEYS.Q31_VALUE,
        '11.18 Do you collaborate or engage in partnerships with non-governmental organizations to promote the implementation of your biodiversity-related goals and commitments?',
        'This question asks information on whether your organization is partnering with nongovernmental organizations (NGOs) to pursue your biodiversity goals and commitments. Involvement in such partnerships provides evidence to investors and other data users that your organization is undertaking a collaborative approach to ensure best practices around biodiversity-related issues. Organizations usually benefit from shared knowledge from NGOs regarding biodiversity-related issues.',
        [
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q31_1_VALUE,
            'Collaborating or partnering with NGOs',
            IS_COLLABORATING_WITH_NGO_OPTIONS
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q31_2_VALUE,
            'Comment',
            2400
          )
        ]
      )
    ]
  },
  {
    key: 'Q32',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_BIODIVERSITY_KEYS.Q32_VALUE,
        '11.18.1 Provide details on main collaborations and/or partnerships with non-governmental organizations that were active during the reporting year.',
        'This question asks details of the main partnerships with non-governmental organizations (NGOs) your organization had in place during the reporting period. Strong and long-term partnerships with environmental NGOs provide evidence to investors and other data users that your organization is really committed to managing biodiversity-related risks.',
        [
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q32_1_VALUE,
            'Organization',
            500
          ),
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q32_2_VALUE,
            'Scope of collaboration',
            SCOPE_OF_COLLABORATION_OPTIONS
          ),
          createRowMultiSelectField(
            CDP_BIODIVERSITY_KEYS.Q32_3_VALUE,
            'Mining project ID',
            PROJECT_OPTIONS
          ),
          createRowMultiSelectField(
            CDP_BIODIVERSITY_KEYS.Q32_4_VALUE,
            'Areas of collaborations',
            BIODIVERSITY_MANAGEMENT_MEASURE_OPTIONS
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q32_5_VALUE,
            'Describe the nature of the collaboration',
            2400
          ),
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q32_6_VALUE,
            'Duration (until)',
            BIODIVERSITY_TIMEFRAME_OPTIONS
          )
        ],
        true,
        CDP_BIODIVERSITY_KEYS.Q31_VALUE,
        CDP_BIODIVERSITY_KEYS.Q31_1_VALUE,
        ['Yes']
      )
    ]
  },
  {
    key: 'Q33',
    showIndex: false,
    items: [
      {
        field: [
          createHeading(
            '11.19 Do you engage with artisanal and small-scale miners operating within your mining project areas or in their area of influence?',
            'This question asks about actions your organization is undertaking to manage risks associated with artisanal and small-scale miners within your mining project areas or in the area of influence of your mining projects. Developing effective ways of engaging with artisanal and small-scale mining (ASM) helps your mining projects to keep their social license to operate, e.g., by preventing conflicts or contributing to reducing environmental harm. This will provide insights to investors and other data users on your risk management approach for ASM.'
          ),
          createSelectField(CDP_BIODIVERSITY_KEYS.Q33_VALUE, '', YES_NO_OPTIONS)
        ]
      }
    ]
  },
  {
    key: 'Q34',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_BIODIVERSITY_KEYS.Q34_VALUE,
        '11.19.1 Describe your engagement approach to artisanal and small-scale mining (ASM) during the reporting year.',
        'This question asks details on the main engagement activities with artisanal and small-scale miners your organization had in place during the reporting period.',
        [
          createRowMultiSelectField(
            CDP_BIODIVERSITY_KEYS.Q34_1_VALUE,
            'Mining project ID',
            PROJECT_OPTIONS
          ),
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q34_2_VALUE,
            'Forms of engagement',
            ASM_INTERVENTION_TYPE_OPTIONS
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q34_3_VALUE,
            'Please explain',
            2400
          )
        ],
        false,
        undefined,
        CDP_BIODIVERSITY_KEYS.Q33_VALUE,
        ['Yes']
      )
    ]
  },
  {
    key: 'Q35',
    showIndex: false,
    items: [
      {
        field: [
          createHeading(
            '11.20 Do you engage with other stakeholders to further the implementation of your policies concerning biodiversity?',
            'Mining organizations and their projects might impact, benefit or maintain relationships with diverse stakeholders. This question gathers information on relevant biodiversity-related engagement initiatives that were not already disclosed in previous questions. Examples provided here will further contribute to the understanding, by investors and other data users, of how broadly and proactively your organization engages with external stakeholders on biodiversityrelated issues.'
          ),
          createSelectField(CDP_BIODIVERSITY_KEYS.Q35_VALUE, '', YES_NO_OPTIONS)
        ]
      }
    ]
  },
  {
    key: 'Q36',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_BIODIVERSITY_KEYS.Q36_VALUE,
        '11.20.1 Provide relevant examples of other biodiversity-related engagement activities that happened during the reporting year.',
        'This question asks for details on other biodiversity-related engagement not covered by the previous questions that happened during the reporting year',
        [
          createRowSelectField(
            CDP_BIODIVERSITY_KEYS.Q36_1_VALUE,
            'Activities',
            LANDSCAPE_INITIATIVE_PARTICIPATION_OPTIONS
          ),
          createRowMultiSelectField(
            CDP_BIODIVERSITY_KEYS.Q36_2_VALUE,
            'Mining project ID',
            PROJECT_OPTIONS
          ),
          createRowWysiwygField(
            CDP_BIODIVERSITY_KEYS.Q36_3_VALUE,
            'Please explain',
            2400
          )
        ],
        true,
        undefined,
        CDP_BIODIVERSITY_KEYS.Q35_VALUE,
        ['Yes']
      )
    ]
  }
];
